export default {
      id: "unresize-usage",
      viewBox: "0 0 33 34",
      url: __webpack_public_path__ + "img/icons.deccda40.svg#unresize",
      toString: function () {
        return this.url;
      }
    }